var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c(
      "div",
      { staticClass: "login_win", attrs: { id: "loginWindow" } },
      [
        _c("TipsWindow", { ref: "tips" }),
        _c("img", {
          staticClass: "close b-close",
          attrs: { src: require("../assets/image/close.png"), alt: "" },
        }),
        _c("img", {
          staticClass: "logo_img",
          attrs: { src: _vm.gameData.logoImage, alt: "" },
        }),
        _c("div", { staticClass: "user_login" }, [
          _c("div", { staticClass: "login_phone" }, [
            _c("i", { staticClass: "fa fa-user color" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.loginId,
                  expression: "loginId",
                },
              ],
              attrs: {
                type: "user",
                placeholder: _vm.$t("account_input_text"),
              },
              domProps: { value: _vm.loginId },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.login.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.loginId = $event.target.value
                },
              },
            }),
          ]),
          _c("div", { staticClass: "login_account" }, [
            _c("i", { staticClass: "fa fa-lock color" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password",
                },
              ],
              attrs: {
                type: "password",
                placeholder: _vm.$t("password_input_text"),
              },
              domProps: { value: _vm.password },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.login.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.password = $event.target.value
                },
              },
            }),
          ]),
        ]),
        _c(
          "button",
          {
            class: [
              "login_button",
              "bg_color",
              _vm.buttonIsActive ? "button_active" : "",
            ],
            attrs: { disabled: _vm.buttonDisabled },
            on: {
              click: function ($event) {
                return _vm.login()
              },
            },
          },
          [_vm._v(_vm._s(_vm.loginButtonText))]
        ),
        _c("p", { staticClass: "methods" }, [
          _vm._v("—— " + _vm._s(_vm.$t("other_login_methods_text")) + " ——"),
        ]),
        _c("div", { staticClass: "third_party" }, [
          _c("div", {
            staticClass: "fb_login_button",
            on: {
              click: function ($event) {
                return _vm.initFacebookPlugin()
              },
            },
          }),
          _c("div", { attrs: { id: "googleLogin" } }),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }